import { Injectable } from '@angular/core';
import { Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import { Opcion } from './selects.service';

const mockCategorias: Opcion[] = [{
  codigo: '001',
  descripcion: 'Categoria 1',
}, {
  codigo: '002',
  descripcion: 'Categoria 2',
}];

@Injectable()
export class CategoriasService {
  private url = 'api/categorias';

  constructor(private sxHttp: SxHttpService) {}

  getForSelect(): Observable<Opcion[]> {
    return Observable.of(mockCategorias);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/categorias.service.ts